/* ImageRollovers Class
Description: Sets up rollover Images using targeted selectors from hard-coded images
Instantiate this class using a JSON object that contains an array of selectors, for hard-coded images that 
have valid image source paths on a local source or remote server. Images must have valid paths. 
The source JSON object of selectors must be composed in this manner:

let ImageNameObjectArray = {
    'RolloverTargets':
        [
            '.selector1',
            '.selector2',
            '.selector3',
            '#selector4',
            '.selector5',
            '.selector6',
            '.selector7,
            '.selector8',
            '#selector9'
        ]
};

You must have a source path prefix: For example, an image that is located here -> https://cdn.skyelearning.com/static/home-page-header-bg-mobile.jpg 
will have a source prefix of: 'https://cdn.skyelearning.com/static/'

The variable for the source prefix should be created in this manner: 
let imageSourcePrefix = 'https://cdn.skyelearning.com/static/';

Instantiation must be done like this: 
let AddRolloverImages = new ImageRollovers(ImageNameObjectArray, imageSourcePrefix);

Then execute the rollover process:
AddRolloverImages.ProcessRollovers();

@method - SelectNode()
@params theSelector: can be any HTML element selector.
        Use: SelectNode(#myDiv) to return a node.

@method - CheckImageSourceProperty()
@params theImageSourceObject: The source JSON object of the image source data.
        thePropertyName: The name of the property that has to be checked via hasOwnProperty().

@method - ProcessRollovers()
        Processes the rollover setup in a loop for all images that are accessed using selectors.

@method - SetupImageRolloverEvents()
        Rollover events are setup using parameters that are provided.
@params eventType: is the type of event i.e. 'click', 'mouseover', 'mouseout', etc.
        imageObject: is the constructed image object that is preloaded
        swapImage: is the preloaded rollover image object "string" path, 
        but this can also accept an object if needed, to grab it's source

@method - BuildRolloverObjects
        Build the preloaded image objects that are used for rollovers.
@params theImageSource: The rollover image source which is a string that will be split to extract the image name.
@params theImageObject: Passed to the SetupImageRolloverEvents method that is run within this method.
*/


class ImageRollovers {

    constructor(ImageNameObject, ImageSourcePrefix, themeData) {
        this.ImageNameObject = ImageNameObject;
        this.ImageSourcePrefix = ImageSourcePrefix;
        this.ImageNameObjectArray = ImageNameObject.RolloverTargets;
        this.ThemeTargetObjectArray = ImageNameObject.ThemeTargets;
        this.themeData = themeData;
    }

    SelectNode(theSelector) {
        return document.querySelector(theSelector);
    }

    CheckImageSourceProperty(theImageSourceObject, propertyName) {
        let hasProperty = false;
        hasProperty = (theImageSourceObject.hasOwnProperty(propertyName)) ? true : false;
        return hasProperty;
    }

    ProcessRollovers() {
        var themeData = this.GetThemeData();
        let verifySourceProp = this.CheckImageSourceProperty(this.ImageNameObject, 'RolloverTargets');
        var imgCounter = 0;
        if (verifySourceProp) {
            for (var imgCounter = 0; imgCounter < this.ImageNameObjectArray.length; imgCounter += 1) {
                let tempImgVariable = document.querySelector(this.ImageNameObjectArray[imgCounter]);
                if (tempImgVariable !== null && tempImgVariable !== '') {
                    var thisImageObject = tempImgVariable;
                    var initialImageSrc = tempImgVariable.src;
                    this.BuildRolloverObjects(initialImageSrc, thisImageObject, themeData);
                }
            }
        }
    }

    SetupImageRolloverEvents(eventType, imageObject, swapImage) {
        imageObject.addEventListener(eventType, () => {
            if (typeof (swapImage) === 'string') {
                imageObject.src = swapImage;
            } else {
                imageObject.src = swapImage.src;
            }
        });
    }

    BuildRolloverObjects(theImageSource, theImageObject, themeData) {

        var originalImageSource = theImageSource;
        var rolloverImgObject = new Image(0, 0);
        var theImageSourceFile = theImageSource.substring(theImageSource.lastIndexOf('/') + 1);
        var theImageName = theImageSourceFile.split('.');
        var rolloverImageName = theImageName[0] + "-" + "roll" + "." + theImageName[1];
        rolloverImgObject.alt = theImageName[0] + " Preload";

        rolloverImgObject.src = this.ImageSourcePrefix + rolloverImageName;
        /* Detect and utilize theme image prefix here if current page uses theme */
        if (themeData !== '' && themeData !== null) {
            for (var cnt = 0; cnt < this.ThemeTargetObjectArray.length; cnt++) {
                if (theImageObject.classList.contains(this.ThemeTargetObjectArray[cnt])) {
                    rolloverImgObject.src = themeData.imgPrefix + rolloverImageName;
                }
            }
        }
     
        rolloverImgObject.style.position = 'absolute';
        rolloverImgObject.style.display = 'none';
        document.body.appendChild(rolloverImgObject);

        this.SetupImageRolloverEvents('mouseover', theImageObject, rolloverImgObject);
        this.SetupImageRolloverEvents('mouseout', theImageObject, originalImageSource);
    }
    
    GetThemeData() {
        return this.themeData;
    }
}

export default ImageRollovers;